import { create } from 'zustand'

const amenitiesCreationState = (set: any) => ({
  addAmenitiesModal: false,
  setAddAmenitiesModal: (state: boolean) =>
    set(() => ({ addAmenitiesModal: state })),
  amenitiesData: null,
  setAmenitiesData: (state: any) => set(() => ({ amenitiesData: state })),
})

export const amenitiesCreationStore = create(amenitiesCreationState)
